var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"40px","padding-top":"10px"}})}
var staticRenderFns = []

export { render, staticRenderFns }